import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@shopify/polaris';

// Status is worked out server-side, per app, from the state plus that app's window.
const TONES = {
  live: 'success',
  scheduled: 'info',
  // Archived is the only one worth colouring: it took something off every app at once.
  ended: undefined,
  unpublished: undefined,
  archived: 'critical',
};

const LABELS = {
  live: 'Live',
  scheduled: 'Scheduled',
  ended: 'Finished',
  unpublished: 'Unpublished',
  archived: 'Archived',
};

const StatusBadge = ({ status }) => (
  <Badge tone={TONES[status]}>{LABELS[status] || status}</Badge>
);

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusBadge;
